export * from './loyalty-opt-in-modal.styled.default';
